import React, { useCallback, useContext, useEffect, useState } from 'react';
import { LocalizationContext, useLocalizedStrings } from 'app/localization/Context';
import { DeviceType, useDeviceStub } from 'app/model/Device';
import { BindActionType } from 'app/model/Bind';

import RadioButton from 'app/home/general-components/RadioButton/RadioButton';
import KeyPad from 'app/home/general-components/Keypad/Keypad';

import { Split } from '../../device/deivce-detail/device-control/remote/RemoteControl';
import { createBindDeviceSpecialInfoObject, getBindTemplate } from 'app/model/BindData';
import { CoolerScenarioSpecialSlection } from '../../device/deivce-detail/device-control/CoolerControl';

import { ReactComponent as IconOnOffWhite } from 'images/device/remote-button/on-off-white.svg';
import { ReactComponent as IconOnOffDark } from 'images/device/remote-button/on-off-dark.svg';
import { ReactComponent as IconMuteWhite } from 'images/device/remote-button/mute-white.svg';
import { ReactComponent as IconMuteDark } from 'images/device/remote-button/mute-dark.svg';

import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconBack } from 'images/general/back.svg';
import { ReactComponent as IconBackBlack } from 'images/general/back-black.svg';

import './RemoteSpecial.scss'


export default function RemoteSpecialPage(props) {
    switch (props.pageData.device.type) {
        case DeviceType.evaporativeCooler:
            return CoolerStatementSpecialPage(props);
        case DeviceType.splitRemote:
            return SplitSpecialPage(props);
        case DeviceType.tvRemote:
            return TVSpecialPage(props);
        default:
            return null;
    }
}


function SplitSpecialPage({
    dismissHandler,
    pageData, back,
    preBind, pushState }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;
    const b = s.createBindProcess;

    const device = pageData.device;
    const deviceName = device.name;
    // for split
    const [deviceToShow, deviceToSend] = useDeviceStub({
        name: device.name,
        mac: device.mac,
        type: device.type,
        config_per_mode: device.config_per_mode
    });

    const nextClick = useCallback(() => {
        const _preBind = { ...preBind };
        let _actionInfos = [..._preBind.actionInfos];
        _actionInfos = _actionInfos.filter(info =>
            (info.data.action_type !== BindActionType.device) ||
            (info.data.device_mac !== device.mac)
        );
        const actTemplate = getBindTemplate(false, device, l);

        _actionInfos.push(createBindDeviceSpecialInfoObject(false, actTemplate.icon, device.name, {
            action_type: BindActionType.device,
            device_mac: device.mac,
            device_type: device.type,
            is_on: deviceToSend["is_on"],
            mode: deviceToSend["mode"],
            set_point: deviceToSend["set_point"],
            fan: deviceToSend["fan"],
        }, l));

        _preBind.actionInfos = _actionInfos;
        pushState({ preBind: _preBind, pageData: { name: 'main' } });
    }, [deviceToSend, preBind, pushState, device, l]);


    return (
        <div className="create-bind-page-content">
            <IconBack className="nav-icon" /> <div className="nav-button" onClick={() => { back(); }} />
            <IconX className="nav-icon-secondary" /> <div className="nav-button-secondary" onClick={dismissHandler} />

            <div className="header">{(pageData.stage === 'if') ? b.if : b.then} {deviceName}</div>
            <div className="info">
                {b.goToState}
            </div>

            <Split device={deviceToShow} sendCommandH={(func) => {
                return () => {
                    deviceToShow.changeState({ 'function': func });
                }
            }} />

            <div style={{ width: 10, height: 64 + 8 }} />

            {/* vvvv in CreateScenario.scss vvvv */}
            <div className="full-blue-button" onClick={nextClick}>
                <div>{b.next}</div> <IconBackBlack className="icon-180" />
            </div>
        </div>
    );
}

function CoolerStatementSpecialPage({
    dismissHandler,
    pageData, back,
    preBind, pushState }) {

    const l = useContext(LocalizationContext);
    const s = l.strings;
    const b = s.createBindProcess;

    const device = pageData.device;
    const deviceName = device.name;

    const [dataToSend, setDataToSend] = useState(undefined);

    const nextClick = useCallback(() => {
        const _preBind = { ...preBind };
        let _actionInfos = [..._preBind.actionInfos];
        _actionInfos = _actionInfos.filter(info =>
            (info.data.action_type !== BindActionType.device) ||
            (info.data.device_mac !== device.mac)
        );
        const actTemplate = getBindTemplate(false, device, l);

        let _data = { ...dataToSend }
        _data.action_type = BindActionType.device;
        _data.device_mac = device.mac;
        _data.device_type = device.type;
        _actionInfos.push(createBindDeviceSpecialInfoObject(false, actTemplate.icon, device.name, _data, l));

        _preBind.actionInfos = _actionInfos;
        pushState({ preBind: _preBind, pageData: { name: 'main' } });
    }, [dataToSend, preBind, pushState, device, l]);

    return (
        <div className="create-bind-page-content">
            <IconBack className="nav-icon" /> <div className="nav-button" onClick={() => { back(); }} />
            <IconX className="nav-icon-secondary" /> <div className="nav-button-secondary" onClick={dismissHandler} />

            <div className="header">{(pageData.stage === 'if') ? b.if : b.then} {deviceName}</div>
            <div style={{ width: 10, height: 16 }} />

            <CoolerScenarioSpecialSlection light setData={setDataToSend} />

            <div style={{ width: 10, height: 36 }} />

            {/* vvvv in CreateScenario.scss vvvv */}
            <div className="full-blue-button" onClick={nextClick}>
                <div>{b.next}</div> <IconBackBlack className="icon-180" />
            </div>
        </div>
    );
}

function TVSpecialPage({
    dismissHandler,
    pageData, back,
    preBind, pushState }) {

    const l = useContext(LocalizationContext);
    const s = l.strings;
    const b = s.createBindProcess;

    const device = pageData.device;
    const deviceName = device.name;

    const [dataToSend, setDataToSend] = useState(undefined);
    const [errorChannelIsEmpty, setErrorChannelIsEmpty] = useState(false);

    const nextClick = useCallback(() => {
        if (errorChannelIsEmpty !== true) {
            const _preBind = { ...preBind };
            let _actionInfos = [..._preBind.actionInfos];
            _actionInfos = _actionInfos.filter(info =>
                (info.data.action_type !== BindActionType.device) ||
                (info.data.device_mac !== device.mac)
            );
            const actTemplate = getBindTemplate(false, device, l);

            let _data = { ...dataToSend }
            _data.action_type = BindActionType.device;
            _data.device_mac = device.mac;
            _data.device_type = device.type;
            _actionInfos.push(createBindDeviceSpecialInfoObject(false, actTemplate.icon, device.name, _data, l));

            _preBind.actionInfos = _actionInfos;
            pushState({ preBind: _preBind, pageData: { name: 'main' } });
        }
    }, [dataToSend, preBind, pushState, device, errorChannelIsEmpty, l]);

    return (
        <div className="create-bind-page-content">
            <IconBack className="nav-icon" /> <div className="nav-button" onClick={() => { back(); }} />
            <IconX className="nav-icon-secondary" /> <div className="nav-button-secondary" onClick={dismissHandler} />

            <div className="header">{(pageData.stage === 'if') ? b.if : b.then} {deviceName}</div>
            <div className="info">
                {b.goToState}
            </div>

            <TVAskStatePage light setData={setDataToSend} setErrorChannelIsEmpty={setErrorChannelIsEmpty} />

            <div style={{ width: 10, height: 36 }} />

            {errorChannelIsEmpty ? <div className="tv-error-label">{b.tvYouMustEnterANumber}</div> : null}
            {/* vvvv in CreateScenario.scss vvvv */}
            <div className="full-blue-button" onClick={nextClick} style={{ opacity: (errorChannelIsEmpty !== true) ? 1 : 0.3 }}>
                <div>{b.next}</div> <IconBackBlack className="icon-180" />
            </div>
        </div>
    );
}

export function TVAskStatePage({ light, setData, setErrorChannelIsEmpty }) {
    const s = useLocalizedStrings();
    const b = s.createBindProcess;

    const [powerC, choosePower] = useState(true);
    const [muteC, chooseMute] = useState(false);
    const [channelC, chooseChannel] = useState(false);
    const [channelStr, setChannelStr] = useState("");

    const powerClickRef = React.createRef();
    const muteClickRef = React.createRef();
    const channelClickRef = React.createRef();

    useEffect(() => {
        if (powerC) {
            setErrorChannelIsEmpty(false);
            setData({
                power: 2
            })
        } else if (muteC) {
            setErrorChannelIsEmpty(false);
            setData({
                mute: 2
            })
        } else if (channelC) {
            setData({
                channel: parseInt(channelStr)
            })
            setErrorChannelIsEmpty(channelStr.length === 0);
        }
    }, [powerC, muteC, channelC, channelStr, setData, setErrorChannelIsEmpty]);

    return (
        <div className={"tv-ask-state-section" + (light ? " light" : "")}>
            <div className={"basic-row" + (!powerC ? " inactive" : "")} ref={powerClickRef} >
                <RadioButton light={light} isOn={powerC}
                    setOn={choosePower} setOffOthers={[chooseMute, chooseChannel]}
                    additionalRef={powerClickRef} />
                {
                    light ? <IconOnOffWhite className="icon" /> :
                        <IconOnOffDark className="icon" />
                }
                <div className="title">{b.tvToggleOnOff}</div>
            </div>
            <div className={"basic-row" + (!muteC ? " inactive" : "")} ref={muteClickRef}>
                <RadioButton light={light} isOn={muteC}
                    setOn={chooseMute} setOffOthers={[choosePower, chooseChannel]}
                    additionalRef={muteClickRef} />
                {
                    light ? <IconMuteWhite className="icon" /> :
                        <IconMuteDark className="icon" />
                }
                <div className="title">{b.tvMute}</div>
            </div>
            <div className={"channel-row" + (!channelC ? " inactive" : "")}>
                <RadioButton light={light} isOn={channelC}
                    setOn={chooseChannel} setOffOthers={[choosePower, chooseMute]}
                    additionalRef={channelClickRef} />
                <div className="title" ref={channelClickRef}>{b.tvChannelTitle}</div>
                <div className="ask-channel-section">
                    <div className="title2">{b.tvChannelLabel}</div>
                    <div className="chan">{channelStr}</div>
                    <KeyPad enable={channelC} light={light} setStrInput={setChannelStr} />
                </div>
            </div>
        </div>
    );
}